import { render, staticRenderFns } from "./PersonalAccessTokens.vue?vue&type=template&id=608de639&scoped=true"
import script from "./PersonalAccessTokens.vue?vue&type=script&lang=js"
export * from "./PersonalAccessTokens.vue?vue&type=script&lang=js"
import style0 from "./PersonalAccessTokens.vue?vue&type=style&index=0&id=608de639&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608de639",
  null
  
)

export default component.exports